import { lazy } from "react";
const Profile = lazy(() => import("../../views/pages/profile"));
const Pricing = lazy(() => import("../../views/pages/pricing"));
const Error = lazy(() => import("../../views/pages/misc/Error"));
const Home = lazy(() => import("../../views/news/home"));
//NEW SCREENS FOR NFTY

const AccountSettings = lazy(() => import("../../views/news/account-settings"));

const PagesRoutes = [
  //NEW SCREENS FOR NFTY
  {
    path: "/account-settings",
    element: <AccountSettings />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/pages/profile",
    element: <Profile />,
  },
  {
    path: "/pages/pricing",
    element: <Pricing />,
  },
  {
    path: "/misc/error",
    element: <Error />,
    meta: {
      publicRoute: true,
      layout: "blank",
    },
  },
  //-----------------------
];

export default PagesRoutes;
